const style = {
  popup: {
    position: "absolute",
    top: "348px",
    left: "583px",
    transform: "translate(-50%, -50%)",
    width: 755,
    backgroundColor: "#FFFFFF",
    borderRadius: "10px",
    boxShadow: 24,
    padding: "30px",
  },
  buttonStyle: {
    marginTop: "30px",
    backgroundColor: "#043D90",
    borderRadius: 8,
    width: 176,
    height: 40,
    // marginLeft: "20%",
    // marginBottom: "20%",
  },
  typography: {
    color: "#8C8C8C",
    fontSize: "20px",
  },
  inputStyle: {
    height: 91,
    width: "100%",
  },
  cancelBtn: {
    marginLeft: "60px",
    marginTop: "30px",
    width: "176px",
    height: "40px",
    color: "#043D90",
    border: "1px solid #043D90",
    borderRadius: "8px",
  },
};

export default style;
